import type { ZammadUserTicket } from "@/mocks/zammadTickets";

interface StatsOverviewProps {
  tickets: ZammadUserTicket[];
}

export default function StatsOverview({ tickets }: StatsOverviewProps) {
  const total = tickets.length;
  const open = tickets.filter((t) => t.status === "open").length;
  const inProgress = tickets.filter((t) => t.status === "in_progress").length;
  const resolved = tickets.filter((t) => t.status === "resolved").length;
  const closed = tickets.filter((t) => t.status === "closed").length;
  const breached = tickets.filter((t) => t.slaBreached).length;
  const rated = tickets.filter((t) => t.satisfactionRating !== null && t.satisfactionRating !== undefined);
  const avgRating = rated.length > 0
    ? (rated.reduce((sum, t) => sum + (t.satisfactionRating || 0), 0) / rated.length).toFixed(1)
    : "-";

  const stats = [
    {
      label: "Total",
      value: total,
      icon: "ri-file-list-3-line",
      color: "text-foreground-700",
      bg: "bg-background-100",
    },
    {
      label: "Abiertos",
      value: open,
      icon: "ri-inbox-line",
      color: "text-accent-600",
      bg: "bg-accent-100",
    },
    {
      label: "En progreso",
      value: inProgress,
      icon: "ri-loader-4-line",
      color: "text-primary-600",
      bg: "bg-primary-100",
    },
    {
      label: "Resueltos",
      value: resolved,
      icon: "ri-check-line",
      color: "text-emerald-600",
      bg: "bg-emerald-100",
    },
    {
      label: "Cerrados",
      value: closed,
      icon: "ri-check-double-line",
      color: "text-emerald-600",
      bg: "bg-emerald-100",
    },
    {
      label: "SLA excedido",
      value: breached,
      icon: "ri-alert-line",
      color: "text-red-600",
      bg: "bg-red-50",
    },
    {
      label: "Satisfacción",
      value: avgRating,
      icon: "ri-star-fill",
      color: "text-amber-600",
      bg: "bg-amber-50",
      isRating: true,
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="rounded-xl bg-background-50 border border-background-200/70 p-4 text-center"
        >
          <div className={`w-9 h-9 rounded-lg ${stat.bg} flex items-center justify-center mx-auto mb-2`}>
            <i className={`${stat.icon} ${stat.color} text-base`}></i>
          </div>
          <div className="text-xl font-heading font-bold text-foreground-950 mb-0.5">
            {stat.value}
            {stat.isRating && stat.value !== "-" && (
              <span className="text-xs text-foreground-400 font-normal">/5</span>
            )}
          </div>
          <p className="text-[10px] text-foreground-500 font-medium">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
